function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0C18.6264 0 24 5.3736 24 12C24 18.6264 18.6264 24 12 24Z",
    fill: "#25D366",
    style: {
      fill: "#25D366",
      fill: "color(display-p3 0.1451 0.8275 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6137 6.4128C16.1257 4.9224 14.1433 4.1016 12.0337 4.0992C7.68732 4.0992 4.14732 7.6368 4.14732 11.9856C4.14732 13.3752 4.50972 14.7336 5.20092 15.9288L4.08252 20.016L8.26332 18.9192C9.41532 19.548 10.7113 19.8792 12.0313 19.8792H12.0337C16.3801 19.8792 19.9177 16.3416 19.9201 11.9928C19.9225 9.8856 19.1041 7.9032 17.6137 6.4128ZM12.0361 18.5472H12.0337C10.8577 18.5472 9.70332 18.2304 8.69772 17.6328L8.45772 17.4912L5.97612 18.1416L6.63852 15.7224L6.48252 15.4752C5.82732 14.4312 5.47932 13.2264 5.47932 11.9856C5.48172 8.3712 8.42172 5.4312 12.0385 5.4312C13.7905 5.4312 15.4345 6.1152 16.6729 7.3536C17.9113 8.592 18.5929 10.2408 18.5905 11.9904C18.5905 15.6072 15.6481 18.5472 12.0361 18.5472ZM15.6313 13.6368C15.4345 13.5384 14.4649 13.0608 14.2849 12.996C14.1049 12.9312 13.9729 12.8976 13.8409 13.0944C13.7089 13.2912 13.3321 13.7352 13.2169 13.8672C13.1017 13.9992 12.9865 14.016 12.7897 13.9176C12.5929 13.8192 11.9569 13.6104 11.2057 12.9384C10.6201 12.4152 10.2241 11.7696 10.1089 11.5728C9.99372 11.376 10.0969 11.268 10.1953 11.1696C10.2841 11.0808 10.3921 10.9392 10.4905 10.824C10.5889 10.7088 10.6225 10.6272 10.6873 10.4952C10.7521 10.3632 10.7209 10.248 10.6705 10.1496C10.6201 10.0512 10.2265 9.0816 10.0633 8.6856C9.90252 8.3016 9.74172 8.3544 9.61932 8.3472C9.50412 8.3424 9.37212 8.34 9.24252 8.34C9.11052 8.34 8.89692 8.3904 8.71692 8.5872C8.53692 8.784 8.02812 9.2616 8.02812 10.2312C8.02812 11.2008 8.73372 12.1392 8.83212 12.2688C8.93052 12.4008 10.2217 14.3904 12.1993 15.2448C12.6697 15.4488 13.0369 15.5688 13.3225 15.66C13.7953 15.8112 14.2249 15.7896 14.5633 15.7392C14.9425 15.6816 15.7297 15.2616 15.8929 14.8032C16.0561 14.3424 16.0561 13.9488 16.0081 13.8672C15.9601 13.7856 15.8281 13.7376 15.6313 13.6368Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/iconWhatsapp.da0d0ec0b1f14f922fd7e6bdcbf29282.svg";
export { ForwardRef as ReactComponent };